

export interface IAppParatemers {
    emailSupport?: boolean;
    smsSupport?: boolean;
    mapSupport?: boolean;

    siteLogoHref?: string;

    companyName?: string;
    companyAddress?: string;

    showDeveloperSettings?: boolean;
    showRawApplicationErrors?: boolean;
    testenviromentBackground?: boolean;

    hideEmptyFieldsFromObservationDetails?: boolean;
    observationPublicByDefault?: boolean;

    allowChangingProcessingMarkingPublicity?: boolean;
    processingMarkingPublicityDefaultValue?: "kaikki" | "ei_mikaan" | "viimeisin";

    allowEditingObservation?: boolean;

    archiveLimit?: string;

    languages?: Array<string>;
    showLanguageSelect?: boolean
    showTenantSwitch?: boolean;
    gateDirectUrl?: string;
    applicationMenuHref?: string;
}



export interface IAppParatemersDTO {

    // Common with all apps
    logo_url?: string;
    sahkoposti_tuki?: boolean;
    sms_tuki?: boolean;
    kartta_tuki?: boolean;
    kehitysvalikko?: boolean;
    nayta_sovellusvirhe_viestit?: boolean;
    yritysen_nimi?: string;
    yrityksen_osoite?: string;

    kielet?: string;
    nayta_kieli_valikko?: string;
    asiakasympariston_vaihto_valikko?: boolean;
    gate_direct_url?: string;
    testiympariston_tausta?: string;
    sovellusvalikko_linkki?: string

    // App spesific
    havainnot_logo_url?: string;
    havainnot_sahkoposti_tuki?: boolean;
    havainnot_sms_tuki?: boolean;
    havainnot_kartta_tuki?: boolean;
    havainnot_kehitysvalikko?: boolean;
    havainnot_nayta_sovellusvirhe_viestit?: boolean;
    havainnot_testiympariston_tausta?: boolean;

    havainnot_yritysen_nimi?: string;
    havainnot_yrityksen_osoite?: string;

    havainnot_arkistointiraja?: string;

    havainnot_piilota_tyhjat_kentant_havainnon_tiedoista?: boolean;
    havainnot_havainnot_oletuksena_julkisia?: boolean;

    havainnot_kasittelymerkintojen_julkisuus_oletusarvo?: "kaikki" | "ei_mikaan" | "viimeisin";
    havainnot_kasittelymerkintojen_julkisuus_valittavissa?: boolean;

    havainnot_salli_havaintojen_muokkaus?: boolean;

    havainnot_kielet?: string;
    havainnot_nayta_kieli_valikko?: string;
    havainnot_asiakasympariston_vaihto_valikko?: boolean;
    havainnot_sovellusvalikko_linkki?: string

};

const ensureBoolean = (uknown: any) => typeof uknown === "boolean" ? uknown : undefined;

/**
 * Mapper primarly uses app spesific parameter and fallbacks to common parameters used in all safety applications.
 */
export const AppParameterMapper = {
    apiToDomain: (api: IAppParatemersDTO): IAppParatemers => {

        console.info("[AppParameterMapper]", api)
        return {

            siteLogoHref: api.havainnot_logo_url || api.logo_url,

            emailSupport: ensureBoolean(api.havainnot_sahkoposti_tuki ?? api.sahkoposti_tuki),
            smsSupport: ensureBoolean(api.havainnot_sms_tuki ?? api.sms_tuki),
            mapSupport: ensureBoolean(api.havainnot_kartta_tuki ?? api.kartta_tuki),

            companyName: api.havainnot_yritysen_nimi || api.yritysen_nimi,
            companyAddress: api.havainnot_yrityksen_osoite || api.yrityksen_osoite,

            showDeveloperSettings: ensureBoolean(api.havainnot_kehitysvalikko ?? api.kehitysvalikko),
            showRawApplicationErrors: ensureBoolean(api.havainnot_nayta_sovellusvirhe_viestit ?? api.nayta_sovellusvirhe_viestit),
            showTenantSwitch: ensureBoolean(api.havainnot_asiakasympariston_vaihto_valikko ?? api.asiakasympariston_vaihto_valikko),
            testenviromentBackground: ensureBoolean(api.havainnot_testiympariston_tausta ?? api.testiympariston_tausta),


            hideEmptyFieldsFromObservationDetails: api.havainnot_piilota_tyhjat_kentant_havainnon_tiedoista,
            observationPublicByDefault: api.havainnot_havainnot_oletuksena_julkisia,
            allowEditingObservation: api.havainnot_salli_havaintojen_muokkaus,


            allowChangingProcessingMarkingPublicity: ensureBoolean(api.havainnot_kasittelymerkintojen_julkisuus_valittavissa),
            processingMarkingPublicityDefaultValue: api.havainnot_kasittelymerkintojen_julkisuus_oletusarvo,


            archiveLimit: api.havainnot_arkistointiraja,

            languages: (api.havainnot_kielet || api.kielet) ? (api.havainnot_kielet ?? api.kielet ?? "").split(",") : undefined,
            showLanguageSelect: ensureBoolean(api.havainnot_nayta_kieli_valikko ?? api.nayta_kieli_valikko),
            gateDirectUrl: api.gate_direct_url,
            applicationMenuHref: api.havainnot_sovellusvalikko_linkki || api.sovellusvalikko_linkki,
        }
    },
};


